module.exports = __webpack_public_path__ + "img/companyEle.53f0be8a.svg";